<template>
  <span class="brains-asset-data-modal-container" :class="{ 'brains-asset-data-modal--hidden': !value }">
    <div class="brains-asset-data-modal" @click="activeModal = false" />
    <div class="brains-asset-data-modal--content mymodalmax" :style="'width:' + width + 'px; min-height:' + minHeight + 'px'">
      <div class="brains-asset-data-modal--content__close-btn">
        <i class="el-icon-close" aria-hidden="true" @click="activeModal = false" />
      </div>
      <slot />
    </div>
  </span>
</template>
<script>
export default {
  name: 'BrainsModal',
  props: {
    value: {
      type: Boolean,
      default: false
    },
    width: {
      type: Number,
      default: 900
    },
    minHeight: {
      type: Number,
      default: 250
    }

  },
  data() {
    return {
      activeModal: this.value
    }
  },
  watch: {
    value() {
      this.activeModal = this.value
    },
    activeModal(newOne, oldOne) {
      this.handleInput()
    }
  },
  methods: {
    handleInput(e) {
      this.$emit('input', this.activeModal)
    },
    maxsize() {
      this.width = window.screen.width - 100
      this.minHeight = window.screen.height - 200
      // document.getElementsByClassName('mymodalmax')[0].style = ''
    }
  }
}
</script>
<style lang="scss" scoped>
.brains-asset-data-modal-container {
  width: 100vw;
  height: 100vh;
  position: fixed;
  top: 0;
  left: 0;
  z-index: 2001;
}

.brains-asset-data-modal {
  position: fixed;
  top: 0;
  left: 0;
  width: 100vw;
  height: 100vh;
  background-color: rgba(0, 0, 0, 0.671);
  z-index: 2001;
  transition: all 0.5s;

  &--hidden {
    display: none !important;
  }
}

.brains-asset-data-modal--content {
  z-index: 2001;
  background-color: white;
  // width: 900px;
  // min-height: 250px;
  margin: auto;
  // position: relative;
  // top: 25vh;

  position: absolute;
  left: 50vw;
  top: 40vh;
  transform: translate(-50%, -50%);

  &__close-btn {
    position: absolute;
    color: rgb(194, 194, 194);
    right: 20px;
    top: 20px;
    cursor: pointer;

    i {
      font-size: 18px;
      font-weight: 600;
    }
  }
}
</style>
